import React, { useCallback, useContext, useState } from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';
import { ViewportContext } from 'src/components/viewport';

import { Direction } from '@prisjakt/ui';
import { ButtonSize, ButtonType } from '@prisjakt/ui/button/variants';
import { DropdownContent } from '@prisjakt/ui/dropdown';
import { IconMenuKebab } from '@prisjakt/ui/icon';
import ReportModal from '../../components/report-button/report-modal';

import { IOptionsColumn } from './types';

import * as RegularStyle from '../styles';
import {
  Dropdown,
  DropdownToggle,
  Option,
  Options,
  ReportOverlay,
} from './styles';

const OptionsColumn: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IOptionsColumn>
>> = props => {
  const { alternativeOffer, featured } = props;
  const { t } = useAppContext();
  const { isMobile } = useContext(ViewportContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  const color = featured ? 'maybeBlue700' : 'base500';

  return (
    <RegularStyle.Column>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        priceId={alternativeOffer.id}
        priceValue={
          alternativeOffer.price && alternativeOffer.price.exclShipping
        }
        productName={alternativeOffer.name}
        stockStatus={alternativeOffer.stock && alternativeOffer.stock.status}
      />

      <Options>
        <Dropdown closeOnItemClick>
          <DropdownToggle
            onlyIcon
            size={ButtonSize.MEDIUM}
            type={ButtonType.TEXT}
          >
            <IconMenuKebab color={color} />
          </DropdownToggle>

          <DropdownContent placement={isMobile ? Direction.Up : Direction.Down}>
            <ReportOverlay>
              <Option type="button" onClick={openModal}>
                {t('feedback', 'dialog.prompt-button')}
              </Option>
            </ReportOverlay>
          </DropdownContent>
        </Dropdown>
      </Options>
    </RegularStyle.Column>
  );
};

export default OptionsColumn;
